import React, { type ComponentType } from 'react';

export type Props = {
	itemType: string | undefined;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	SelectItemTypeModal: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	AddLinkModal: ComponentType<Record<any, any>>;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	AddRepositoryModal: ComponentType<Record<any, any>>;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (props: Props) => {
	const { itemType, AddRepositoryModal, AddLinkModal, SelectItemTypeModal } = props;
	if (itemType === 'repository') {
		return <AddRepositoryModal />;
	}

	if (itemType === 'link') {
		return <AddLinkModal />;
	}

	return <SelectItemTypeModal />;
};
